import { render, staticRenderFns } from "./AgencyMessageHome.vue?vue&type=template&id=dae6bb0a&scoped=true"
import script from "./AgencyMessageHome.vue?vue&type=script&lang=js"
export * from "./AgencyMessageHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae6bb0a",
  null
  
)

export default component.exports